import { setContext } from "@apollo/client/link/context";

import { permissionsData } from "@/data";

export const authHeaders = (getAccessTokenSilently) =>
    setContext(async (_, previousContext) => {
        const token = await getAccessTokenSilently();

        return {
            headers: {
                ...previousContext.headers,
                Authorization: `Bearer ${token}`,
            },
        };
    });

export const canDo = (user, permissions, oneOfPermissions) => {
    if (user) {
        if (oneOfPermissions) return permissions?.some((permission) => user[permissionsData.key]?.includes(permission));
        return permissions?.every((permission) => user[permissionsData.key]?.includes(permission));
    }
};

export const hasRole = (user, roles) => {
    let filteredArray = [];

    if (user) {
        filteredArray = user[permissionsData.rolesKey].filter((role) => roles.indexOf(role) !== -1);

        return filteredArray.length !== 0;
    }
};
